import { useState } from 'react'
import PrimaryButton from './PrimaryButton'
import ContactCards from './ContactCards'

const reasons = [
  { label: 'Vorführung buchen', id: 'appointment' },
  { label: 'Kundensupport', id: 'support' },
  { label: 'Allgemeine Anfrage', id: 'general' },
]

const reason = ''

const name = 'Name'

const email = 'Email'

const inquiry = 'Text'

const submit = 'Absenden'

const genericError = 'Something went wrong, please try again.'

const disclaimer = 'Ihre nachricht wurde an neomento übermittelt. Wir melden uns in kürze.'

const Input = ({
  label,
  id,
  type,
}: {
  label: string
  id: string
  type?: string
}) => (
  <div className="mb-6 text-grayDarkLight space-y-4">
    <label className="text-sm uppercase tracking-widest" htmlFor={id}>
      {label}
    </label>
    <input
      className="border border-grayDarkLight rounded-2xl w-full py-2 px-3"
      id={id}
      name={id}
      type={type || 'text'}
      placeholder=""
      required
    />
  </div>
)

const TextArea = ({ label, id }: any) => (
  <div className="mb-12 text-grayDarkLight space-y-4">
    <label className="text-sm uppercase tracking-widest" htmlFor={id}>
      {label}
    </label>
    <textarea
      className="border border-grayDarkLight rounded-2xl w-full py-2 px-3 h-32"
      id={id}
      name={id}
      placeholder=""
      required
    />
  </div>
)

const RadioInput = ({ label, options }: any) => (
  <div className="mb-14 sm:mb-10 text-grayDarkLight space-y-4 text-center">
    <label>{label}</label>
    <div className="sm:flex sm:space-x-4 sm:space-y-0 space-y-4">
      {options.map(({ label, id }: any) => (
        <div key={id}>
          <label htmlFor={id}>
            <input
              className="hidden peer"
              type="radio"
              id={id}
              name="reason"
              value={id}
              required
              defaultChecked={id === options[0].id}
            />
            <div className="hidden peer-checked:block font-bold py-2 rounded-full text-white bg-main px-4 md:px-8 text-sm">
              {label}
            </div>
            <div className="peer-checked:hidden font-bold py-2 rounded-full text-grayDarkLight border border-grayDarkLight px-4 md:px-8 cursor-pointer text-sm">
              {label}
            </div>
          </label>
        </div>
      ))}
    </div>
  </div>
)

const ContactForm = () => {
  const [hasError, setHasError] = useState(false)
  const [hasSent, setHasSent] = useState(false)

  const postContactRequest = async (event: any) => {
    event.preventDefault()

    try {
      const res = await fetch('/api/contact', {
        body: JSON.stringify({
          reason: event.target.reason.value,
          name: event.target.name.value,
          email: event.target.email.value,
          inquiry: event.target.inquiry.value,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })

      if (res.status !== 200) {
        throw Error('Form submission failed')
      }

      event.target.reset()
      setHasSent(true)
    } catch (e) {
      setHasError(true)
    }
  }

  return hasSent ? (
    <div className="flex flex-col items-center mt-20">
      <img
        className="w-36 mb-14"
        src="contact/success.svg"
        alt="success"
      />
      <p className="tex-grayDarkLight uppercase text-sm text-center">{disclaimer}</p>
      <div className="mt-28 sm:w-full lg:w-2/3 xl:w-2/4">
        <ContactCards />
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center">
      <div>
        <form onSubmit={postContactRequest}>
          <RadioInput label={reason} options={reasons} />

          <Input label={name} id="name" type="name" />

          <Input label={email} id="email" type="email" />

          <TextArea label={inquiry} id="inquiry" />

          <PrimaryButton type="submit" title={submit} fullWidth />

          {hasError && <p className="text-red italic">{genericError}</p>}
        </form>
        <ContactCards />
      </div>
    </div>
  )
}

export default ContactForm
